import { Component, Input } from '@angular/core';
import { ContextualActionComponent } from './contextual-action.component';

@Component({
  moduleId: module.id,
  selector: 'import-review-aces-action',
  templateUrl: 'import-review-aces-action.component.html',
  styleUrls: ['contextual-action.component.scss'],
})
export class ImportReviewAcesActionComponent extends ContextualActionComponent {
  @Input() importComplete: boolean = false;

  onImportClick() {
    const action = {
      type: 'import-apps',
      action: 'import-apps',
      meta: {
        statusId: 5
      }
    };
    this.actionSelected.emit(action);
  }
}
